import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled, { css } from 'styled-components';

import { Button } from '@/ui/Button/Button';
import { Flex } from '@/ui/Flex/Flex';
import { Modal } from '@/ui/Modal/Modal';

import { CreatedPlayersList } from '../AdminEditPage';

const StyledDownloadButton = styled(Button)`
  ${({ disabled }) =>
    disabled &&
    css`
      background-color: ${({ theme }) => theme.color('#B2B1BA')};
      pointer-events: none;
    `}
  margin-bottom: 10px;
`;

const StyledTextWrap = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 35px;
`;

const StyledFooter = styled(Flex)`
  border-top: solid 1px ${({ theme }) => theme.color('#ECEAF5')};
  margin-bottom: 20px;
`;

type Props = {
  readonly isModalOpen: boolean;
  readonly setIsModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  readonly createdPlayersList: readonly CreatedPlayersList[];
};

const handleReponseDownload = (item: CreatedPlayersList) => {
  const responseString = JSON.stringify(item);
  const responseData = new Blob([responseString], {
    type: 'application/json',
  });
  const fileDownload = document.createElement('a');
  fileDownload.href = window.URL.createObjectURL(responseData);
  fileDownload.download = `${item.hostname ?? ''}.config.json`;
  fileDownload.click();
};

export const CreatedPlayersModal = ({
  isModalOpen,
  setIsModalOpen,
  createdPlayersList,
}: Props) =>
  isModalOpen ? (
    <Modal onClose={() => setIsModalOpen(false)} title="Created new players">
      <StyledTextWrap>
        <div>
          <FormattedMessage
            defaultMessage="1. Download the file(s) below and move the file to one of the prepared USB Sticks available in the office. Make sure to rename the file to config.json , overwrite any existing file if necessary."
            id="QQMIHX"
          />
        </div>
        <div>
          <FormattedMessage
            defaultMessage="2. Take a PC, connect a Screen, Keyboard, Ethernet Cable and Power Adapter. In order to get into the BIOS, immediately after power on, press F9 until a BIOS Screen appears."
            id="jA2UD4"
          />
        </div>
        <div>
          <FormattedMessage
            defaultMessage="3. Change the “After power loss” setting to “return to previous state”. this will make sure the PC starts up automatically once power is supplied"
            id="Fn4pBx"
          />
        </div>
        <div>
          <FormattedMessage
            defaultMessage="4. Change the Boot Order to boot from the USB stick and save + exit the BIOS"
            id="KG2p3U"
          />
        </div>
        <div>
          <FormattedMessage
            defaultMessage="5. The OS is now flashing to the device, and the computer will turn off once that process is done"
            id="ERwVLv"
          />
        </div>
        <div>
          <FormattedMessage
            defaultMessage="6. Remove the USB stick and re-boot the PC using the power cord. You can now check Status field in the Admin Screen of the Web Manager and the device should be shown as Online."
            id="7FjY9Q"
          />
        </div>
      </StyledTextWrap>
      <StyledFooter />
      {createdPlayersList.map((item) => (
        <Flex className="row" justify="space-between" key={item.hostname}>
          {item.hostname}
          <StyledDownloadButton onClick={() => handleReponseDownload(item)}>
            <FormattedMessage defaultMessage="Download Response" id="LBsT/L" />
          </StyledDownloadButton>
        </Flex>
      ))}
    </Modal>
  ) : null;
